import { all } from 'redux-saga/effects'
import { topicSagas } from './topic/topic.sagas'

export function * topicRootSagas () {
  yield all([
    topicSagas(),
  ])
}
